export const CONFIG_CALENDAR_VIETNAMESE = {
    firstDayOfWeek: 0,
    dayNames      : [
        'Chủ nhật',
        'Thứ hai',
        'Thứ ba',
        'Thứ tư',
        'Thứ năm',
        'Thứ 6',
        'Thứ 7'
    ],
    dayNamesShort: ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'],
    dayNamesMin  : ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'],
    monthNames   : [
        'Tháng một',
        'Tháng  hai',
        'Tháng ba',
        'Tháng tư',
        'Tháng năm',
        'Tháng sáu',
        'Tháng bảy',
        'Tháng tám',
        'Tháng chín',
        'Tháng mười',
        'Tháng mười một',
        'Tháng mười hai'
    ],
    monthNamesShort: [
        'T1',
        'T2',
        'T3',
        'T4',
        'T5',
        'T6',
        'T7',
        'T8',
        'T9',
        'T10',
        'T11',
        'T12'
    ],
    today: 'Hôm nay',
    clear: 'xóa'
};
